import "./salesRecordSkeleton.css";

const SalesRecordSkeleton = () => {
  return (
    <div className='sales-skeleton'>
      {/* Header Section */}
      {/*      <div className='sales-skeleton__header'>
        <div className='sales-skeleton__title'></div>
        <div className='sales-skeleton__search-container'>
          <div className='sales-skeleton__dropdown'></div>
          <div className='sales-skeleton__search-input'></div>
          <div className='sales-skeleton__search-btn'></div>
        </div>
      </div> */}

      {/* Content Area */}
      <div className='sales-skeleton__content'>
        {/* Left Panel - Sales List */}
        <div className='sales-skeleton__left-panel'>
          {/* Filter Tabs */}
          <div className='sales-skeleton__filter-tabs'>
            <div className='sales-skeleton__tab sales-skeleton__tab--active'></div>
            <div className='sales-skeleton__tab'></div>
            <div className='sales-skeleton__tab'></div>
          </div>

          <div className='sales-skeleton__date-filter'>
            <div className='sales-skeleton__date-dropdown'></div>
          </div>

          {/* Sales Items List */}
          <div className='sales-skeleton__sales-list'>
            {[1, 2, 3, 4].map((index) => (
              <div key={index} className='sales-skeleton__sale-item'>
                <div className='sales-skeleton__item-avatar'></div>
                <div className='sales-skeleton__item-info'>
                  <div className='sales-skeleton__item-name'></div>
                  <div className='sales-skeleton__item-price'></div>
                </div>
                <div className='sales-skeleton__item-details'>
                  <div className='sales-skeleton__item-quantity'></div>
                  <div className='sales-skeleton__item-date'></div>
                  <div className='sales-skeleton__item-total'></div>
                </div>
              </div>
            ))}
          </div>

          {/* Total Section */}
          <div className='sales-skeleton__total-section'>
            <div className='sales-skeleton__total-label'></div>
            <div className='sales-skeleton__total-amount'></div>
            <div className='sales-skeleton__download-btn'></div>
          </div>
        </div>

        {/* Right Panel - Charts */}
        <div className='sales-skeleton__right-panel'>
          {/* Chart Title */}
          <div className='sales-skeleton__chart-title'></div>

          {/* Chart Legend */}
          <div className='sales-skeleton__chart-legend'>
            <div className='sales-skeleton__legend-item'>
              <div className='sales-skeleton__legend-color sales-skeleton__legend-color--blue'></div>
              <div className='sales-skeleton__legend-label'></div>
            </div>
            <div className='sales-skeleton__legend-item'>
              <div className='sales-skeleton__legend-color sales-skeleton__legend-color--gray'></div>
              <div className='sales-skeleton__legend-label'></div>
            </div>
          </div>

          {/* Bar Chart */}
          <div className='sales-skeleton__bar-chart'>
            <div className='sales-skeleton__chart-y-axis'>
              {[1, 2, 3, 4, 5, 6, 7, 8].map((index) => (
                <div key={index} className='sales-skeleton__y-axis-label'></div>
              ))}
            </div>
            <div className='sales-skeleton__chart-bars'>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((index) => (
                <div key={index} className='sales-skeleton__bar-container'>
                  <div className='sales-skeleton__bar sales-skeleton__bar--primary' style={{ height: `${Math.random() * 80 + 20}%` }}></div>
                  <div className='sales-skeleton__x-axis-label'></div>
                </div>
              ))}
            </div>
          </div>

          {/* Pie Chart Section */}
          <div className='sales-skeleton__pie-section'>
            <div className='sales-skeleton__pie-title'></div>
            <div className='sales-skeleton__pie-chart-container'>
              <div className='sales-skeleton__pie-chart'></div>
              <div className='sales-skeleton__pie-legend'>
                {[1, 2, 3].map((index) => (
                  <div key={index} className='sales-skeleton__pie-legend-item'>
                    <div className='sales-skeleton__pie-legend-color'></div>
                    <div className='sales-skeleton__pie-legend-label'></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesRecordSkeleton;
